import React from 'react';

import { PERMISSION_PARTNER_TRANSPORT } from 'pages/PartnerTransport/utils/constants';

const PartnerTransportPage = React.lazy(() => import('pages/PartnerTransport/pages/PartnerTransportPage'));
const PartnerTransportAddPage = React.lazy(() => import('pages/PartnerTransport/pages/PartnerTransportAddPage'));

const partnerTransportRoute = [
  {
    path: '/partner-transport',
    exact: true,
    name: 'Danh sách đơn vị vận chuyển',
    function: PERMISSION_PARTNER_TRANSPORT.VIEW,
    component: PartnerTransportPage,
  },
  {
    path: '/partner-transport/add',
    exact: true,
    name: 'Thêm mới đơn vị vận chuyển',
    function: PERMISSION_PARTNER_TRANSPORT.ADD,
    component: PartnerTransportAddPage,
  },
  {
    path: '/partner-transport/edit/:id',
    exact: true,
    name: 'Chỉnh sửa đơn vị vận chuyển',
    function: PERMISSION_PARTNER_TRANSPORT.EDIT,
    component: PartnerTransportAddPage,
  },
  {
    path: '/partner-transport/detail/:id',
    exact: true,
    name: 'Chi tiết đơn vị vận chuyển',
    function: PERMISSION_PARTNER_TRANSPORT.VIEW,
    component: PartnerTransportAddPage,
  },
];

export default partnerTransportRoute;
